import React, { Component } from 'react';
import ApplicantStatusAPI from '../api/ApplicantStatusAPI';
import './ApplicantStatus.css';
import PreloadGif from '../static/images/Preloader.gif';
import PhoneIcon from '../static/images/telephone-call.webp';
import LandlineIcon from '../static/images/old-typical-phone.webp';
import EmailIcon from '../static/images/email.webp';
import MessengerIcon from '../static/images/messenger.webp';

function showIt(elementId) {
    var el = document.getElementById(elementId);
    el.scrollIntoView(true);
}

export class ApplicantStatus extends Component {
    static displayName = ApplicantStatus.name;

    componentDidMount(){
      //alert(localStorage.getItem("token"));
      if(localStorage.getItem("token") === null)
      window.location.href = '/Sign-in';
      ApplicantStatusAPI();
      }

  render() {
      return (
          <div className="applicant-status">
            <div className="card applicant-status-card">
                <form>
                      <div>
                          <p className="text-center applicant-status-message-header">Current Stage</p>
                          <h2 id="StatusMessage" className="text-center applicant-status-message"></h2>
                      </div>
                      <div className="text-center">
                          <img src={PreloadGif} id='StatusImage' className='applicant-status-main-image'></img>
                          <h4 id="futureMapuan" className="text-center mapua-blue future-mapuan">Hello, <span id="studentName" className="mapua-red">Future Mapúan</span>!</h4>
                      </div>
                      <div id="stageApplied" className="stage-applied">
                          <p className="text-center applicant-status-text">
                              Congratulations on your successful application!<br /><br />
                              Please fill out the pre-enrollment questionnaire that you can find in your registered email address inbox.
                          </p>
                      </div>
                      <div id="stagePreEnrollmentSurvey" className="stage-preenrollment-survey">
                          <p className="text-center applicant-status-text">
                              Please answer the pre-enrollment questionnaire that you can find in your registered email address inbox!<br /><br />
                              Also, you may now proceed with the payment of the P400.00 Application Fee either via <a href="https://mcl.edu.ph/maps-and-directories/" className="applicant-status-link">on-site</a> or <a href="https://mcl.edu.ph/admissions/" className="applicant-status-link">off-site</a> payment channels. For current <span className="mapua-red fw-bold">Mapúa</span> <span className="mapua-blue fw-bold">MCL-SHS</span> students applying for College, the Application Fee payment is waived.
                          </p>
                      </div>
                      <div id="stageApplicationFeePayment" className="stage-application-fee-payment">
                          <p className="text-center applicant-status-text">
                              Thank you for your payment of the Application Fee!<br /><br />
                              Your examination schedule can be viewed via this portal; regularly check this portal and your registered email for other details about your application status.
                          </p>
                      </div>
                      <div id="stageExaminationSchedule" className="stage-examination-schedule">
                          <p className="text-center applicant-status-text">
                              Your Diagnostic Examination schedule is on<br /><br /><span id="examDate" className="mapua-red">(TBA)</span><br /><br />
                              at 
                              <span> <a target="_blank" className="applicant-status-link" href="https://www.google.com/maps/place/Map%C3%BAa+Malayan+Colleges+Laguna/@14.2439236,121.0958357,15z/data=!4m10!1m2!2m1!1smalayan+colleges+laguna!3m6!1s0x33bd629241fc760d:0x9484846735393d76!8m2!3d14.2439236!4d121.1123152!15sChdtYWxheWFuIGNvbGxlZ2VzIGxhZ3VuYZIBEnByaXZhdGVfdW5pdmVyc2l0eeABAA!16s%2Fm%2F02z5203?hl=en-US&entry=ttu">
                                  Mapúa Malayan Colleges Laguna, Block 6 Lot 4 Southpoint Subdivision, Pulo-Diezmo Road, Cabuyao City, Laguna.
                              </a></span><br /><br />
                              Regularly check this portal and your registered email for other details and important reminders about your examination.
                          </p>
                      </div>
                      <div id="stageAcceptanceLetter" className="stage-acceptance-letter">
                          <p className="text-center applicant-status-text">
                              We are delighted to inform you that you  <span className="fw-bold fst-italic">PASSED </span> the <span className="mapua-red fw-bold">Mapúa</span>-<span className="mapua-blue fw-bold">Malayan</span> Diagnostic Examination!<br /><br />For your official acceptance letter and enrollment procedure, please check your registered email address.
                          </p>
                      </div>
                      <div id="stageEnrollmentStatus" className="stage-enrollment-status">
                          <h4 className="text-center">Welcome to <span className="mapua-red">Mapúa </span><span className="mapua-blue">Malayan Colleges Laguna</span>!</h4>
                          <p className="text-center applicant-status-text">
                              Please refer to the following links to access the step-by-step procedure for completing your New Student Clearance<br /><br />
                              <ul className="text-start">
                                  <li>
                                      <p>
                                          New Student Clearance Instructional Video<br />
                                          <div class="d-flex justify-content-start">
                                              <a href="https://youtu.be/cFtFwieAbCg" target="_blank" className="applicant-status-anchor-button" id='programCollege'>College</a><br />
                                              <a href="https://youtu.be/vJccc5Z39jg" target="_blank" className="applicant-status-anchor-button" id='programSHS'>Senior High School</a><br />
                                          </div>
                                      </p>
                                  </li>
                                  {/*<li>*/}
                                  {/*    Important Dates and Locations*/}
                                  {/*</li>*/}
                              </ul>
                              {/*<div id="examinationSchedules" className="table px-5">*/}
                              {/*    <div className="row">*/}
                              {/*        <div className="col mapua-blue text-start small fw-bold ms-0">*/}
                              {/*            New Student Orientation Schedule<br /><p id="NSODateTime" className="mapua-red fw-normal mb-0">(TBA)</p>*/}
                              {/*        </div>*/}
                              {/*    </div>*/}
                              {/*    <div className="row border-top-0">*/}
                              {/*        <div className="col mapua-blue text-start small fw-bold ms-0">*/}
                              {/*            Mapúa English Language Test (MELT) Schedule<br /><p id="MELTDateTime" className="mapua-red fw-normal mb-0">(TBA)</p>*/}
                              {/*        </div>*/}
                              {/*    </div>*/}
                              {/*    <div className="row border-top-0">*/}
                              {/*        <div className="col mapua-blue text-start small fw-bold ms-0">*/}
                              {/*            Room Assignment for MELT<br /><p id="MELTRoom" className="mapua-red fw-normal mb-0">(TBA)</p>*/}
                              {/*        </div>*/}
                              {/*    </div>*/}
                              {/*</div>*/}
                              <ul className="text-start">
                                <li>
                                    OneMCL and BlackBoard Learn (BBL) Account Access
                                </li>
                            </ul>
                              <div id="accountCredentials" className="table account-credentials">
                                  <div className="row">
                                      <div className="col mapua-blue text-center small fw-bold ms-0">
                                          OneMCL Username: <br /><span id="oneMCLUsername" className="mapua-red fw-normal">---</span><br />
                                          OneMCL Default Password: <br /><span id="oneMCLPassword" className="mapua-red fw-normal">---</span><br />
                                      </div>
                                      <div className="col mapua-blue text-center small fw-bold ms-0">
                                          BBL Username: <br /><span id="BBLUsername" className="mapua-red fw-normal">---</span><br />
                                          BBL Default Password: <br /><span id="BBLPassword" className="mapua-red fw-normal">---</span><br />
                                      </div>
                                  </div>
                              </div>
                              <div id="accountCredentialsNotReady" className="text-center mapua-red fw-bold small">
                                  Your OneMCL and BlackBoard Learn Accounts are not ready yet, please regularly check this portal for updates.
                              </div>
                              <span className="mapua-blue fw-bold small"><br />NOTE: Student ID and Enrollment Kit will be released upon completion of New Student Clearance</span>
                          </p>
                      </div>
                      <div id="stageTimeout" className="stage-timeout">
                          <p className="text-center applicant-status-text">
                              Your session has timed-out<br /><br />
                              Please try logging in to the Applicant Portal again<br /><br/>
                          </p>
                      </div>
                      <div id="contactChannels" className="contact-channels text-center">
                          Kindly click the Admissions Helplines below for questions and concerns regarding your admission:<br /><br />
                          <label for="item-admissions-helplines" className="toggle text-center mx-auto">Admissions Helplines</label>
                          <input type="checkbox" name="one" id="item-admissions-helplines" className="hide-input" onClick={() => showIt("toggled")} />
                          <div id="toggled" className="toggle-el">
                              <div className="row text-center p-2">
                                  <div className="col-sm">
                                      <span>
                                          <img
                                              alt="Phone Numbers"
                                              src={PhoneIcon}
                                              width="25px"
                                              height="25px"
                                          />
                                      </span><br />
                                      <small>
                                          09190875722<br />
                                          09189902266<br />
                                      </small>
                                      <br />
                                  </div>
                                  <div className="col-sm">
                                      <span>
                                          <img
                                              alt="Landline Number"
                                              src={LandlineIcon}
                                              width="25px"
                                              height="25px"
                                          />
                                      </span><br />
                                      <small>
                                          (049)832-1150<br />
                                      </small>
                                      <br />
                                  </div>
                                  <div className="col-sm">
                                      <span>
                                          <img
                                              alt="Admissions Email"
                                              src={EmailIcon}
                                              width="25px"
                                              height="25px"
                                          />
                                      </span><br />
                                      <small>
                                          <a href="mailto:admissions@mcl.edu.ph" target="_blank" className="links">admissions@mcl.edu.ph</a><br />
                                      </small>
                                      <br />
                                  </div>
                                  <div className="col-sm">
                                      <span>
                                          <img
                                              alt="Admissions Messenger"
                                              src={MessengerIcon}
                                              width="25px"
                                              height="25px"
                                          />
                                      </span><br />
                                      <small>
                                          <a href="https://www.facebook.com/MapuaMCLAdmissions/" target="_blank" className="links">Mapúa MCL Admissions Office</a><br />
                                      </small>
                                  </div>
                              </div>
                          </div>
                      </div>
                </form>
             </div>
      </div>
    );
  }
}
